module.exports = [{
      plugin: require('/Users/tweissin/dev/aws-musicalshowcases/musicalshowcases/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"google":{"families":["Roboto"]}},
    },{
      plugin: require('/Users/tweissin/dev/aws-musicalshowcases/musicalshowcases/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
